// extracted by mini-css-extract-plugin
export default {"pageWrap":"PageWrap_pageWrap__s0Tsk","backgroundWrap":"PageWrap_backgroundWrap__+SdiJ"};